import { Shield, Car } from "lucide-react";

export const CoverageOptions = () => {
  return (
    <div className="grid md:grid-cols-2 gap-8 mb-12">
      <div className="bg-white p-8 rounded-lg shadow-sm animate-scale-in" style={{ animationDelay: "0.2s" }}>
        <h2 className="text-2xl font-semibold text-primary-dark mb-4">
          Coverage Options
        </h2>
        <ul className="space-y-4">
          <li className="flex items-start">
            <Shield className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
            <div>
              <h3 className="font-medium">Liability Coverage</h3>
              <p className="text-neutral">Protects against damage to others' property and injuries.</p>
            </div>
          </li>
          <li className="flex items-start">
            <Car className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
            <div>
              <h3 className="font-medium">Collision Coverage</h3>
              <p className="text-neutral">Covers damage to your vehicle from accidents.</p>
            </div>
          </li>
          <li className="flex items-start">
            <Shield className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
            <div>
              <h3 className="font-medium">Comprehensive Coverage</h3>
              <p className="text-neutral">Protection against theft, weather damage, and other non-collision incidents.</p>
            </div>
          </li>
        </ul>
      </div>

      <div className="bg-white p-8 rounded-lg shadow-sm animate-scale-in" style={{ animationDelay: "0.4s" }}>
        <h2 className="text-2xl font-semibold text-primary-dark mb-4">
          Additional Benefits
        </h2>
        <ul className="space-y-4">
          <li className="flex items-start">
            <Shield className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
            <div>
              <h3 className="font-medium">24/7 Claims Support</h3>
              <p className="text-neutral">Round-the-clock assistance when you need it most.</p>
            </div>
          </li>
          <li className="flex items-start">
            <Car className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
            <div>
              <h3 className="font-medium">Rental Car Coverage</h3>
              <p className="text-neutral">Transportation coverage while your vehicle is being repaired.</p>
            </div>
          </li>
          <li className="flex items-start">
            <Shield className="h-6 w-6 text-primary mr-2 flex-shrink-0" />
            <div>
              <h3 className="font-medium">Quick Claims Processing</h3>
              <p className="text-neutral">Fast and efficient claims handling for your peace of mind.</p>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
};